class APIS {
    apis() {
        return {
            fetch: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/flag/fetch'
            },
            add: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/flag/create'
            },
            update: {
                headers: {
                    'xt-user-token': null
                },
                method: 'put',
                path: '/backend/flag/update/:id'
            },
            client: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/flag/client'
            },
            assign: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/flag/assign'
            },
            unAssign: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/flag/unassign'
            },
            customers: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/flag/customers'
            }
        }
    }
}

export default new APIS;